import * as React from "react";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";
import { ICouncil } from "src/interfaces";
import Loading from "src/components/general/Loading";
import axios from "axios";
import { baseUrl } from "src/constants/ApiSettings";
import { FormatNumber } from "src/components/utils/FormatNumber";
import * as qs from "query-string-for-all";

interface ITrace {
  name: string;
  roads: number;
  fullName: string;
}

interface IState {
  data: ITrace | null;
}

interface IProps {
  ordinal: number;
  council: ICouncil;
  year: string;
}

export default class RoadSignTrace extends React.PureComponent<
IProps,
IState,
ICouncilIdentityBadge
> {
  public state: IState = { data: null };

  public componentDidMount() {
    this.generateData(this.props.council, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateData(newProps.council, newProps.year);
    }
  }

  public generateData = (council: ICouncil, year: string) => {
    axios
      .get(
        `${baseUrl}/totalRoadLengthServicedPerCapita?${qs.stringify({
          council: council.id,
          year
        })}`
      )
      .then(res => {
        const roads = res.data[0].value;
        const data = {
          fullName: council.name,
          name: `${council.name}`,
          roads: Math.round(roads)
        };
        this.setState({ data });
      })
      .catch(err => {
        // tslint:disable-next-line:no-console
        console.error(err);
      });
  };

  public render() {
    const index = this.props.ordinal - 1;
    const council = this.state.data;

    if (!council) {
      return <Loading />;
    }

    return (
      <div className="road-sign__council flex items-center">
        <div className="road-sign__name w-3/4 pr-5">
          <CouncilIdentityBadge
            badge={index + 1}
            name={council.name}
            inverse={ true }
          />
        </div>
        <div className="road-sign__label w-1/4 text-right whitespace-no-wrap">{ FormatNumber( council.roads, 0 ) }<span className="text-base"> m</span></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Roads/RoadSignTrace.tsx